"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const IntegrationSharedSettings_1 = require("../IntegrationSharedSettings");
const react_2 = require("@osmosys/react");
exports.CampaignMonitorSettings = ({ integration }) => {
    return (react_1.default.createElement(reusables_1.Form, { mutationProps: {
            mutation: graphql_1.updateCampaignMonitor,
            refetchQueries: [
                {
                    query: graphql_1.integration,
                    variables: {
                        id: integration.id,
                    },
                },
            ],
        }, valuesToVariables: values => {
            const data = {
                campaignMonitorClientId: null,
                campaignMonitorClientName: null,
                name: values.name.trim(),
            };
            if (values.campaignMonitorClient) {
                data.campaignMonitorClientId = values.campaignMonitorClient.id;
                data.campaignMonitorClientName = values.campaignMonitorClient.name;
            }
            return {
                data,
                id: integration.id,
            };
        }, formikProps: {
            initialValues: {
                campaignMonitorClient: integration.campaignMonitorClientId &&
                    integration.campaignMonitorClientName
                    ? {
                        id: integration.campaignMonitorClientId,
                        name: integration.campaignMonitorClientName,
                    }
                    : undefined,
                name: integration.name,
            },
            validationSchema: () => Yup.object().shape({
                name: Yup.string()
                    .trim()
                    .required('Required'),
            }),
        }, showBottomToolbar: true }, formikProps => {
        var _a, _b;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IntegrationSharedSettings_1.IntegrationSharedSettings, { integration: integration, formikProps: formikProps, hasAccessKey: true },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "mt-2 w-100" }),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { showLabel: true, boldLabel: true, resourceName: "client", resourceNamePlural: "clients", query: graphql_1.campaignMonitorClients, skip: !integration || !integration.canConnect, variables: {
                            id: integration.id,
                        }, value: formikProps.values.campaignMonitorClient, selectFirstIfNoValue: false, disabled: !((_a = integration) === null || _a === void 0 ? void 0 : _a.canConnect), placeholder: !((_b = integration) === null || _b === void 0 ? void 0 : _b.canConnect)
                            ? 'Connect to Campaign Monitor before selecting a client'
                            : undefined, paths: {
                            count: '__length',
                            label: 'name',
                            list: 'campaignMonitorClients',
                            value: 'id',
                        }, onChange: val => {
                            formikProps.setFieldValue('campaignMonitorClient', val);
                        } })))));
    }));
};
//# sourceMappingURL=CampaignMonitorSettings.js.map